export const storageAuthKey = "authTokens";
export const facebookAppId = `${process.env.REACT_APP_FACEBOOK_APP_ID}`;
export const facebookAppSecret = `${process.env.REACT_APP_FACEBOOK_APP_SECRET}`;
export const googleClientId = `${process.env.REACT_APP_GOOGLE_CLIENT_ID}`;

export const isDev = process.env.REACT_APP_TEST_MODE === "true";
